export default "__VITE_ASSET__846de578__"